/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Next_Error_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Go to next error" |
*
* @param {Error_Nav_Next_Error_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_next_error_aria_label = /** @type {((inputs?: Error_Nav_Next_Error_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Next_Error_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a l'erreur suivante")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum nächsten Fehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai all'errore successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к следующей ошибке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al siguiente error")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转到下一个错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のエラーへ進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगली त्रुटि पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o próximo erro")
	return /** @type {LocalizedString} */ ("Go to next error")
});